export const IconCheckCorrect: {
  name: 'icon_check_correct-9a3647acaca7'
} = {
  name: 'icon_check_correct-9a3647acaca7'
}
